"use client";

import { ProgressBar, OverlayTrigger, Tooltip } from "react-bootstrap";

const Animated = ({ value = 0, status = "offline", tooltipText = "" }) => {
  const variantMap = {
    working: "success",
    break: "warning",
    idle: "info",
    offline: "secondary",
  };

  return (
    <OverlayTrigger
      placement="top"
      overlay={
        <Tooltip>
          {tooltipText}
        </Tooltip>
      }
    >
      <div>
        <ProgressBar
          now={value}
          animated={status === "working"}
          variant={variantMap[status] || "secondary"}
          style={{
            height: "12px",
            backgroundColor: "transparent",
            border: "1px solid #dee2e6",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        />
      </div>
    </OverlayTrigger>
  );
};

export default Animated;
